const createUser = "/createUser";
const getTherapist = "/getTherapist";
// Legacy DaySchedule availability routes. Older flow only; not used now.
const getTimeSlotOfTherapist = "/therapistTimeSlot"
const getAllTherapistTimeSlots = "/allTherapistTimeSlots"
// Current live availability routes used by the active internal booking flow.
const getAllTherapistInternalBooking = "/Internal_Booking"
const getTherapistInternalBooking = "/Internal_Booking_By_Doctor"
const getAllTherapist = "/getAllTherapist"
const createInternalBooking = "/createInternalBooking"
const getAllTherapistAvailableTimeSlots = "/allTherapistAvailableTimeSlots"
const createHoldBooking = "/hold-booking/create"
const listHoldBookings = "/hold-booking/list"
const getHoldBookingByToken = "/hold-booking/token"
const confirmHoldBookingByToken = "/hold-booking/token"
const reactivateHoldBooking = "/hold-booking"
const changeHoldBookingSlot = "/hold-booking"
const cancelHoldBooking = "/hold-booking"
//Added foe RequestBookings
const RequestcreateUser = "/leadGeneration/form";
const RequestcreateBooking = "/leadGeneration/bookingForm"
const getTherapistById = "/getTherapistById"
const createFreelanceBooking = "/createFreelanceBooking"

export {
    createUser,
    getTherapist,
    getAllTherapist,
    getTimeSlotOfTherapist,
    getAllTherapistTimeSlots,
    getAllTherapistInternalBooking,
    getTherapistInternalBooking,
    createInternalBooking,
    getAllTherapistAvailableTimeSlots,
    createHoldBooking,
    listHoldBookings,
    getHoldBookingByToken,
    confirmHoldBookingByToken,
    reactivateHoldBooking,
    changeHoldBookingSlot,
    cancelHoldBooking,
    RequestcreateUser,
    RequestcreateBooking,
    getTherapistById,
    createFreelanceBooking
}
